import React, { Component } from "react";
import styled from "styled-components";
import ContentEditable from "react-contenteditable";
import { marked } from "marked";
import TurndownService from "turndown";
import { t } from "js/i18n";

const Container = styled.div`
    font-size: 14px;
    width: 100%;
    height: 100%;
    
    ul {
        margin: 10px 0px 10px 0px;
    }
    
    h1, h2, h3, h4 {
        margin: 0;
        margin-bottom: 10px;
        font-size: 16px;
    }
    
    h4 {
        font-size: 14px;
    }
    
    table td {
        border: solid 1px #ccc;
        padding: 4px 10px;
    }
    
    
    .editable {
        outline: none;
        height: 100%;
    }
    
    p {
        margin-bottom: 10px;
        line-height: 1.4;
    }
    
    textarea {
        width: 100%;
        height: 100%;
        resize: none;
        outline: none;
        border: none;
        font-family: "Source Sans Pro";
        font-size: 14px;
        min-height: 150px;
    }
    
`;

export class AiSlideContentEditor extends Component {
    constructor(props) {
        super(props);

        this.state = {
            html: this.normalizeText(props.text)
        };
        this.isEditing = false;
    }

    normalizeText(text) {
        // strip outer quotes from text
        text = text?.replace(/^"+|"+$/g, "");

        let html = marked.parse(text ?? "", { breaks: true });
        // strip trailing <br>
        html = html.replace(/<br>$/g, "");

        return html;
    }

    componentDidUpdate(prevProps) {
        if (prevProps.text !== this.props.text && !this.isEditing) {
            this.setState({ html: this.normalizeText(this.props.text) });
        }
    }

    getMarkdown() {
        let markdown = new TurndownService().turndown(this.state.html);
        return markdown;
    }

    handleChange = event => {
        let { onChange } = this.props;
        let value = event.target.value.substr(0, 50000);
        this.setState({ html: value });
        onChange(value);
    }

    handlePaste = event => {
        event.preventDefault();
        const text = event.clipboardData.getData("text/plain").substr(0, 50000);
        document.execCommand("insertText", false, text);
    }

    handleFocus = () => {
        this.isEditing = true;
    }

    handleBlur = () => {
        this.isEditing = false;
    }

    render() {
        const { html } = this.state;

        return (
            <Container>
                <ContentEditable
                    className="editable"
                    html={html}
                    onChange={this.handleChange}
                    onPaste={this.handlePaste}
                    onFocus={this.handleFocus}
                    onBlur={this.handleBlur}
                    placeholder={t("Enter a description of the slide...")}
                />
            </Container>
        );
    }
}
